import { Card, CardContent, Grid, Paper, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Loading from '../components/Loading';
import { useCreateSKUMutation, useListSKUsQuery } from '../features/model/skuSlice';

const CustomItemAddNewCard = ({onAddCustomItem = null}) => {
    const addNewCustomItem = (name) => {
        if(onAddCustomItem) {
            onAddCustomItem(name);
        }
    }

    return (
        <Paper elevation={1}><Card key="add_new" sx={{width: 360, minHeight: 180, paddingTop: 2}}>
            <center><Typography variant="subtitle1">Add new custom item</Typography></center>
            <center><TextField
                sx={{marginTop: 2, width: 320}}
                placeholder='Type a new item code and press enter...'
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        addNewCustomItem(e.target.value);
                    }
                }}
            /></center>
        </Card></Paper>);
}

const CustomItemCard = (sku) => {
    return <Paper><Card>
      <CardContent>
        <Typography variant="subtitle2">{sku.code}</Typography>
        </CardContent></Card></Paper>
}

const CustomItemsBrowser = () => {
    const {data: skus, error, isLoading } = useListSKUsQuery({item_type: "custom"});
    const [createSKU] = useCreateSKUMutation();

    if (isLoading || !skus) {
      return <Loading />;
    }
    if (error) {
      return <div>Error: {error}</div>
    }

    const makeLinkToItem = (sku_id) => {
      return `/customitems/${sku_id}/edit`
    }

    const addCustomItem = (code) => {
      let new_sku = {
        name: code,
        code: code,
        item_type: "custom"
      };
      createSKU({data: new_sku});
    }

    console.log(skus)

    return (
      <>
        <Grid container spacing={2} sx={{marginTop: 2, marginBottom: 4}}>
          {skus.objects.map((sku, i) => <Grid item key={sku.id} component={Link} to={makeLinkToItem(sku.id)}>{CustomItemCard(sku)}</Grid>)}
          <Grid item key="add_new"><CustomItemAddNewCard onAddCustomItem={addCustomItem}/></Grid>
        </Grid>
      </>
    );
}

export default CustomItemsBrowser;
